// extracted by mini-css-extract-plugin
export var active = "_68-a";
export var activeIndicator = "_68-9";
export var disabled = "_68-b";
export var fullWidth = "_68-2";
export var lg = "_68-7";
export var md = "_68-6";
export var redoButtonTabGroup = "_68-0";
export var sm = "_68-5";
export var tabButton = "_68-4";
export var tabButtonsContainer = "_68-1";
export var themeDestructive = "_68-d";
export var themeNormal = "_68-c";
export var themeSuccess = "_68-e";
export var xl = "_68-8";
export var xs = "_68-3";